<div *ngIf="data">
  <div class="row" style="border-bottom: 2px solid #ccc; margin-bottom: 7px">
    <div class="col-sm-11 movable">
      <h3
        class="head"
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
      >
        {{ data.mode | uppercase }} TEMPLATE
      </h3>
    </div>

    <div class="col-sm-1">
      <button
        type="button"
        class="btn btn-dark btn-circle btn-xl"
        [mat-dialog-close]="true"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
  <form [formGroup]="addOrEditform">
    <div class="successMessage alert-dismissible">
      <div *ngIf="warningMessage" class="alert alert-warning" role="alert">
        {{ warningMessage }}
        <button
          type="button"
          class="btn-close"
          (click)="removeMessage()"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>
  
      <div *ngIf="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
      <button
        type="button"
        class="btn-close"
        (click)="removeMessage()"
        data-bs-dismiss="alert"
        aria-label="Close"
      ></button>
      </div>
    </div>
    <div class="row" style="margin-top: 10px">
      <div class="col-md-4 col-sm-6">
        <div class="drpchildctrl">
            <span class="v1"></span>
            <label class="searchLable" >DOCK</label>
          <p-dropdown [options]="data.dock" formControlName ="dock" [filter]="true" [virtualScroll]="true"
          [itemSize]="25" [showTransitionOptions]="'0ms'" placeholder="--Select--" optionLabel="dock"
          [resetFilterOnHide]="true" [hideTransitionOptions]="'0ms'" autoWidth="true"
          [filterBy]="'dock'"
          [panelStyle]="{ width: '65%' }" 
          [style]="{ width: '100%' }"  appendTo="body" scrollHeight="180px"
          (onChange)="onDockChange()">
        </p-dropdown>
        <ng-container *ngIf="!addOrEdit.dock.value.dock && submitted">
          <small *ngIf="!addOrEdit.dock.value.dock">
            Dock is required.
          </small>
        </ng-container>
          </div>
      </div>
      
      <div class="col-md-4 col-sm-6">
        <div class="drpchildctrl">
            <span class="v1"></span>
            <label class="searchLable" >RENBAN FROM</label>
          <p-dropdown [options]="filteredRenbanList" formControlName ="selectedrenbanFrom" [filter]="true" [virtualScroll]="true"
          [itemSize]="25" [showTransitionOptions]="'0ms'" placeholder="--Select--" optionLabel="container_renban"
          [resetFilterOnHide]="true" [hideTransitionOptions]="'0ms'" autoWidth="true"
          [filterBy]="'container_renban'"
          [panelStyle]="{ width: '75%' }" 
          [style]="{ width: '100%' }" appendTo="body" scrollHeight="180px">
        </p-dropdown>
        <ng-container *ngIf="!addOrEdit.selectedrenbanFrom.value.container_renban && submitted">
          <small *ngIf="!addOrEdit.selectedrenbanFrom.value.container_renban">
            Renban From is required.
          </small>
        </ng-container>
          </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="drpchildctrl">
            <span class="v1"></span>
            <label class="searchLable" >RENBAN TO</label>
          <p-dropdown [options]="filteredRenbanList" formControlName ="selectedrenbanTo" [filter]="true" [virtualScroll]="true"
          [itemSize]="25" [showTransitionOptions]="'0ms'" placeholder="--Select--" optionLabel="container_renban"
          [resetFilterOnHide]="true" [hideTransitionOptions]="'0ms'" autoWidth="true"
          [filterBy]="'container_renban'"
          [panelStyle]="{ width: '75%' }" 
          [style]="{ width: '100%' }" appendTo="body" scrollHeight="180px">
        </p-dropdown>
        <ng-container *ngIf="!addOrEdit.selectedrenbanTo.value.container_renban && submitted">
          <small *ngIf="!addOrEdit.selectedrenbanTo.value.container_renban">
            Renban To is required.
          </small>
        </ng-container>
          </div>
      </div>
    </div>
    
    <!-- <div class="row" style="margin-top: 10px">
      
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label required class="searchLable">GROUP NAME</label>
          <input
          formControlName="groupName"
          class="key"
          type="text"
          placeholder="--Type--"
          maxlength="20"
          />
          <ng-container *ngIf="addOrEdit.groupName.errors && submitted">
            <small *ngIf="addOrEdit.groupName.errors?.required">
              Group Name is required.
            </small>
          </ng-container>
        </div>
      </div>
      <div class="row" style="margin-top: 10px">
      <div class="col-md-6">
        <div class="drpchildctrl">
          <span class="v1"></span>
          <label class="searchLable">COUNT CYCLE</label>
          <input
          formControlName="countCycle"
          class="key"
          type="text"
          placeholder="--Type--"
          (input)="onInput($event)"
          maxlength="3"
          />
          <ng-container *ngIf="addOrEdit.countCycle.errors && submitted">
            <small *ngIf="addOrEdit.countCycle.errors?.required">
              Count Cycle is required.
            </small>
          </ng-container>
        </div>
      </div>
          </div>
        </div> -->

    <ng-container *ngIf="errorMessage1">
      <p style="color: red ;">{{ errorMessage1 }}</p>
    </ng-container>
  </form>
 
  
  <div class="text-right" style="margin-top: 30px">
    <button class="review_btn" mat-button (click)="callRespectiveFunction()">
      Download Excel
    </button>

    <button class="cancel_btn" mat-button mat-dialog-close="cancel">
      Cancel
    </button>
  </div>
</div>
